import {
  ApiResponse,
  ApiResponseData,
  get,
} from 'utils/apis/insuranceLounge'

import {
  CacheResponse,
  GenericAction,
} from 'state/types'

import {
  ActionTypes,
  UseageTypes,
  UseageApiData,
} from 'state/attributes/home/useageTypes/types'

const {
  CACHE_USEAGE_BEGIN,
  CACHE_USEAGE_SUCCESS,
  CACHE_USEAGE_FAILURE,
} = ActionTypes

const fetchUseageTypes = async (): Promise<UseageApiData> => {
  const useageTypes: ApiResponse = await get('/attributes/home/useage-types')

  if (!useageTypes.success) {
    throw useageTypes
  }

  return useageTypes.data as UseageApiData
}

// eslint-disable-next-line import/prefer-default-export
export const cacheAllUseageTypes = () => async (dispatch: Function, getState: Function): CacheResponse => {
  if (getState().attributes.home.useageTypes.cached || getState().attributes.home.useageTypes.loading) {
    return true
  }

  dispatch(cacheUseageTypesBegin())

  return await fetchUseageTypes()
    .then((useageTypes: UseageApiData) => {
      let keyedUseageTypes: UseageTypes = {}
      if (useageTypes) {
        useageTypes.map((useageType: string) => {
          keyedUseageTypes = {
            ...keyedUseageTypes,
            [useageType[0].toUpperCase + useageType.slice(1)]: useageType,
          }

          return
        })
      }

      dispatch(cacheUseageTypeSuccess(keyedUseageTypes))
    })
    .catch(error => {
      dispatch(cacheUseageTypesFailure(error))

      return Promise.reject(error.message || 'Unable to cache home useageTypes.')
    })
}

const cacheUseageTypesBegin = (): GenericAction => ({ type: CACHE_USEAGE_BEGIN })

const cacheUseageTypeSuccess = (useageTypes: UseageTypes): GenericAction => ({
  type: CACHE_USEAGE_SUCCESS,
  payload: { useageTypes: useageTypes },
})

const cacheUseageTypesFailure = (error: ApiResponseData): GenericAction => ({
  type: CACHE_USEAGE_FAILURE,
  payload: { error },
})
